import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeviceLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" {...props}>
    <rect width={12} height={12} x={0.25} fill="#0582FF" rx={6} />
    <path fill="#fff" d="M4.75 9.205V2.797h1.251v5.292h2.907v1.116z" />
  </svg>
);
export default SvgDeviceLeft;
